export function getDownloadUrl(filePath: string, params: Record<string, string | undefined> = {}) {
  const normalizedPath = filePath.trim().replace(/\\/g, '/').replace(/^\/+/, '');
  const encodedPath = normalizedPath.split('/').filter(Boolean).map(encodeURIComponent).join('/');
  const searchParams = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value) searchParams.set(key, value);
  });

  const query = searchParams.toString();
  return `/api/download/${encodedPath}${query ? `?${query}` : ''}`;
}
